import React from 'react';
import { connect } from 'react-redux';

import { authenticateUser } from '../../../../store/auth';
import SignupWrapper from '../Landing/components/SignupForm';

import './Signup.scss';

const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

const mapDispatchToProps = {
  authenticateUser,
};

export default (store) => ({
  path : 'register',
  component: connect(mapStateToProps, mapDispatchToProps)(props => (
    <div className='container'>
      <div className='page-layout__viewport'>
        <div className='SignupWrapper'>
          <h2 className='FormSegment__title'>Register</h2>
          <SignupWrapper />
        </div>
      </div>
    </div>
  )),
});



// WEBPACK FOOTER //
// ./src/routes/company/routes/Signup/index.js